"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressLine = void 0;
var react_1 = __importStar(require("react"));
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var ProgressLine = function (_a) {
    var list = _a.list, selectedIndex = _a.selectedIndex, className = _a.className, id = _a.id, eventCallback = _a.eventCallback;
    var _b = react_1.useState('0px'), dotPosition = _b[0], setDotPosition = _b[1];
    var listRef = react_1.useRef(null);
    var getDotPosition = react_1.useCallback(function () {
        var _a, _b;
        var selectedChild = (_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b[selectedIndex];
        setDotPosition((selectedChild === null || selectedChild === void 0 ? void 0 : selectedChild.offsetLeft) + (selectedChild === null || selectedChild === void 0 ? void 0 : selectedChild.clientWidth) / 2 + "px");
    }, [selectedIndex, listRef]);
    react_1.useEffect(function () {
        getDotPosition();
    }, [getDotPosition]);
    react_1.useEffect(function () {
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.PROGRESS_LINE_LOAD, { id: id });
    }, [eventCallback, id]);
    return (react_1.default.createElement("div", { className: "tw-relative " + className, "data-testid": "progress-line-wrapper-" + id },
        react_1.default.createElement("div", { className: 'tw-w-full tw-flex tw-relative tw-mb-2', "data-testid": "progress-line-" + id },
            react_1.default.createElement("div", { className: 'tw-bg-TEXT_PRIMARY tw-h-0.5 tw-transition-all', style: { width: "" + dotPosition }, "data-testid": "progress-line-selected-" + id }),
            react_1.default.createElement("div", { className: 'tw-h-2 tw-w-2 tw-rounded-full tw-bg-TEXT_PRIMARY tw-absolute -tw-top-[3px] tw-left-0 tw-transition-all', style: { left: "" + dotPosition }, "data-testid": "progress-line-dot-" + id }),
            react_1.default.createElement("div", { className: 'tw-bg-BASE_PRIMARY tw-h-0.5 tw-transition-all', style: { width: "calc(100% - " + dotPosition + ")" }, "data-testid": "progress-line-unselected-" + id })),
        react_1.default.createElement("div", { className: 'tw-flex tw-justify-between tw-w-full', ref: listRef, "data-testid": "progress-line-label-container-" + id }, list.map(function (item, index) { return (react_1.default.createElement("div", { key: item === null || item === void 0 ? void 0 : item.value, className: selectedIndex >= index ? 'tw-text-TEXT_PRIMARY f-14-400' : 'tw-text-TEXT_TERTIARY f-14-300', "data-testid": "progress-line-label-" + (item === null || item === void 0 ? void 0 : item.value) + "-" + id }, item.label)); }))));
};
exports.ProgressLine = ProgressLine;
